<div class="mb-2" [attr.lang]="metadataValue.language">
   <div class="{{field.styleValue}}">
    <ds-truncatable [id]="truncableId">
      <ds-truncatable-part [id]="truncableId" [minLines]="3">
        <span [innerHTML]="metadataValue.value | dsEscapeHtml" data-test="formatted-text"></span>
      </ds-truncatable-part>
    </ds-truncatable>
  </div>
</div>
